export default "__VITE_ASSET__aece00f6__"